/**
 * Initializes Sentry's context to the user.
 */

import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import * as Sentry from '@sentry/browser';
import get from 'lodash.get';

import { MeQuery } from '../../graphql/queries/account';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const SentryUserInit = ({ user }) => {
  const userId = get(user, 'id');

  useEffect(() => {
    if (userId) {
      Sentry.configureScope(scope => {
        scope.setUser({
          id: userId,
        });
      });
    }
  }, [userId]);

  return null;
};

SentryUserInit.propTypes = propTypes;

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const withUserData = graphql(MeQuery, {
  props: ({ data, loading }) => ({
    user: data.me,
    loading,
  }),
  options: () => ({
    ssr: false, // Important not to load on the server
  }),
  skip: ownProps => !ownProps.authenticated,
});

export default compose(connect(mapStateToProps), withUserData)(SentryUserInit);
